import { render } from "./EmailCodePopup.vue?vue&type=template&id=a6d89dc0"
import script from "./EmailCodePopup.vue?vue&type=script&lang=js"
export * from "./EmailCodePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__